import graphql from './graphql';

const query = /* GraphQL */ `
  query Terminal_list {
    Terminal_list {
      name
      id
    }
  }
`;

const terminalList = async () =>
  // eslint-disable-next-line camelcase
  graphql(query).then(({ Terminal_list }) => Terminal_list);

export default terminalList;
